import { OnboardingStepProps } from '../types';
import { Formik, Form, Field, FieldArray } from 'formik';
import * as Yup from 'yup';

import VsimavecHead from '../../../assets/vsimavec-head.svg';
import { Button } from '../../buttons/Button';
import FormInput from '../../forms/FormInput';
import API from '../../../lib/api';
import { ChangeEvent, useState } from 'react';

export function StepInvite({ onNext }: OnboardingStepProps) {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validationSchema = Yup.object().shape({
        emails: Yup.array()
            .of(Yup.string().email('Neplatná e-mailová adresa').nullable())
            .test(
                'at-least-one',
                'Musíte zadat alespoň jeden e-mail',
                function (emails) {
                    console.log('emails', emails);
                    return (
                        emails &&
                        emails.some((email) => email && email.trim() !== '')
                    );
                }
            ),
    });

    const initialValues = {
        emails: ['', '', '', '', ''], // Default 5 empty inputs
    };

    const handleSubmit = (values: { emails: string[] }) => {
        console.log('values', values);
        const validEmails = values.emails.filter(
            (email) => email && email.trim() !== ''
        );
        console.log('Sending invitations to:', validEmails);

        setIsSubmitting(true);

        API.post('/institution/invitations', { emails: validEmails })
            .then(() => {
                onNext('intro-video');
            })
            .catch((err) => {
                console.log(err);
            }).finally(() => {
                setIsSubmitting(false);
            });
    };

    return (
        <>
            {/* Header */}
            <div className="text-center">
                <div className="mx-auto mb-6 w-20">
                    <img
                        src={VsimavecHead}
                        alt="Logo"
                        className="h-full w-full object-contain"
                    />
                </div>
                <h1 className="text-5xl">Pozvěte své kolegy do Všímavce</h1>
                <p className="mb-6 text-ink-800">
                    Nechcete-li teď nikoho přidávat, můžete to udělat kdykoli
                    později v Nastavení → Organizace.
                </p>
            </div>

            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleChange }) => (
                    <Form className="contents">
                        {/* Email Section */}
                        <div className="mb-2 flex w-full max-w-[480px] flex-1 flex-col">
                            <div className="mb-4">
                                <label
                                    htmlFor="emails"
                                    className="block font-medium"
                                >
                                    E-maily{' '}
                                    <span className="text-red-500">*</span>
                                </label>
                            </div>

                            <FieldArray name="emails" validateOnChange={false}>
                                {({ push, remove }) => (
                                    <div className="space-y-3">
                                        {values.emails.map((_, index) => (
                                            <div
                                                key={index}
                                                className="flex items-center gap-2"
                                            >
                                                <div className="flex-1">
                                                    <FormInput
                                                        name={`emails.${index}`}
                                                        label={null}
                                                        onChange={handleChange}
                                                        value={values.emails[index] ?? ''}
                                                        type="email"
                                                        placeholder="Zadejte e-mailovou adresu"
                                                    />
                                                    {/* <Field
                                                        name={`emails.${index}`}
                                                        component={FormInput}
                                                        placeholder="Zadejte e-mailovou adresu"
                                                        type="email"
                                                    /> */}
                                                    {errors.emails &&
                                                        Array.isArray(
                                                            errors.emails
                                                        ) &&
                                                        errors.emails[index] &&
                                                        touched.emails &&
                                                        Array.isArray(
                                                            touched.emails
                                                        ) &&
                                                        touched.emails[
                                                            index
                                                        ] && (
                                                            <div className="mt-1 text-sm text-red-500">
                                                                {
                                                                    errors
                                                                        .emails[
                                                                        index
                                                                    ]
                                                                }
                                                            </div>
                                                        )}
                                                </div>
                                                {values.emails.length > 1 && (
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            remove(index);
                                                        }}
                                                        className="p-1 text-red-500 hover:text-red-700"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        <button
                                            type="button"
                                            onClick={() => {
                                                push('');
                                            }}
                                            className="text-sm text-blue-600 hover:text-blue-800"
                                        >
                                            + Přidat další e-mail
                                        </button>
                                    </div>
                                )}
                            </FieldArray>

                            {errors.emails &&
                                typeof errors.emails === 'string' && (
                                    <div className="mt-2 text-sm text-red-500">
                                        {errors.emails}
                                    </div>
                                )}
                        </div>

                        {/* Info text */}
                        <div className="flex w-full max-w-[540px] flex-col gap-2">
                            <p className="text-center text-sm font-normal text-ink-800">
                                &#9432; Zadaným adresám pošleme e-mail
                                s&nbsp;pozvánkou do&nbsp;aplikace. Každý
                                uživatel si&nbsp;zvolí své&nbsp;vlastní heslo
                                a&nbsp;bude moci aplikaci ihned používat.
                            </p>

                            <Button
                                type="submit"
                                color="product"
                                disabled={isSubmitting}
                                className="text-base"
                            >
                                Poslat pozvánky
                            </Button>
                            <Button
                                color="product"
                                variant="secondary"
                                onClick={() => onNext('intro-video')}
                                className="text-base"
                            >
                                Pokračovat k aplikaci
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}
